window.jQuery = require('jquery')
window.Cookies = require('js-cookie')
window.Mousetrap = require('mousetrap')
require('@rails/ujs').start()
